<template>
	<div class="basic-container">
		<div>
			<div class="tool-box mobile-hide">
				<div class="search-bar">
					<input placeholder="검색" v-model="keywords" v-on:keyup.enter="searchKeyword" />
				</div>
				<div class="selectbox-area mobile-hide" v-if="viewType === 'consult'">
					<div class="select-wrapper cols-shot">
						<select v-model="qnaType">
							<option value="" selected>문의유형</option>
							<option v-for="(codeVO, i) in qnaTypeList" :key="i" :value="codeVO.code">{{ codeVO.name }}</option>
						</select>
					</div>
				</div>
			</div>
			<!-- 쪽지함 -->
			<section class="table-area" v-if="viewType !== 'consult' && viewType !== 'qna'">
				<div class="table-header mobile-hide" ref="table">
					<div class="col-no">번호</div>
					<div>제목</div>
					<div class="col-date" v-text="viewType === 'receive' ? '수신일' : '발송일'">수신일</div>
					<div class="col-date" v-text="viewType === 'receive' ? '작성자' : '받는자'">작성자</div>
					<div class="col-date">상태</div>
				</div>
				<!--   wdb   -->
				<article class="table-list mobile-hide" v-for="(item, i) in boardList" v-bind:key="'inbox_web' + i">
					<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
					<div class="pl-10">
						<!--						<nav-link :url="'/board/' + type + '/' + boardVO.boardIdx">-->
						<a @click="moveDetail(item.seqNo)">
							{{ item.contentTitle }}
						</a>
					</div>
					<div class="col-date">{{ $moment(item.regDate).format('YYYY.MM.DD') }}</div>
					<div class="col-date">{{ viewType === 'receive' ? item.sendUserNmKor : item.receiveUserNmKor }}</div>
					<div class="col-date">
						<span class="color-red" v-if="!item.receivedDate">안읽음</span>
						<span class="color-blue" v-else>읽음</span>
					</div>
				</article>
				<!--   md   -->
				<article class="table-list web-hide" v-for="(item, i) in boardList" v-bind:key="'inbox_mobile' + i">
					<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
					<div class="">
						<!--						<nav-link :url="'/board/' + type + '/' + boardVO.boardIdx">-->
						<a @click="moveDetail(item.seqNo)">
							{{ item.contentTitle }}
						</a>
					</div>
					<div class="col-date col-line">{{ $moment(item.regDate).format('YYYY.MM.DD') }}</div>
					<div class="col-date">{{ viewType === 'receive' ? item.sendUserNmKor : item.receiveUserNmKor }}</div>
					<div class="col-state">
						<span class="color-red" v-if="!item.receivedDate">안읽음</span>
						<span class="color-blue" v-else>읽음</span>
					</div>
				</article>
			</section>
			<!--1:1온라인상담-->
			<section class="table-area" v-if="viewType === 'consult'">
				<div class="table-header mobile-hide" ref="table">
					<div class="col-no">번호</div>
					<div class="col-date">문의유형</div>
					<div>제목</div>
					<div class="col-date">등록일</div>
					<div class="col-date">작성자</div>
					<div class="col-date">상태</div>
				</div>
				<!--   wdb   -->
				<article class="table-list mobile-hide" v-for="(item, i) in boardList" v-bind:key="'web_' + item.qnaSeqNo">
					<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
					<div class="col-date">
						<p v-if="item.qnaType === 'PROGRAM'">프로그램</p>
						<p v-if="item.qnaType === 'FEE'">정산</p>
						<p v-if="item.qnaType === 'ETC'">기타</p>
					</div>
					<div class="pl-4">
						<a @click="moveDetail(item.qnaSeqNo, item.userSeqNo)">
							{{ item.contentTitle }}
						</a>
					</div>
					<div class="col-date">{{ $moment(item.regDate).format('YYYY.MM.DD') }}</div>
					<div class="col-date">{{ item.adminType == 'ADMIN' ? 'OKTA마케팅지원팀' : item.userNmKor }}</div>
					<div class="col-date">
						<span v-if="item.commentYn === 'N'" class="color-red">답변대기</span>
						<span v-if="item.commentYn === 'Y'" class="color-blue">답변완료</span>
					</div>
				</article>
				<!--   mobile   -->
				<article class="table-list web-hide" v-for="(item, i) in boardList" v-bind:key="'mobile_' + item.qnaSeqNo">
					<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
					<div class="col-title">
						<a @click="moveDetail(item.qnaSeqNo, item.userSeqNo)">
							<v-clamp :max-lines="1" autoresize :expanded="isTableResize">{{ item.contentTitle }}</v-clamp>
						</a>
					</div>
					<div class="col-date col-line">
						{{ item.modDate === null ? $moment(item.regDate).format('YYYY.MM.DD') : $moment(item.modDate).format('YYYY.MM.DD') }}
					</div>
					<div class="col-date">{{ item.userNmKor }}</div>
					<div class="col-auto mobile-hide">
						<p v-if="item.qnaType === 'PROGRAM'">프로그램</p>
						<p v-if="item.qnaType === 'FEE'">정산</p>
						<p v-if="item.qnaType === 'ETC'">기타</p>
					</div>
					<div class="col-state">
						<span v-if="item.commentYn === 'N'" class="color-red">답변대기</span>
						<span v-if="item.commentYn === 'Y'" class="color-blue">답변완료</span>
					</div>
				</article>
			</section>

			<!--      자주하는질문-->
			<section class="qna-table-area" v-if="viewType === 'qna'">
				<div class="table-header mobile-hide" ref="table">
					<div class="col-no">번호</div>
					<div class="">질문</div>
				</div>
				<article class="table-list" v-for="(row, i) in boardList" :key="'faq_' + i">
					<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
					<div class="qna-textbox cursor" @click="showOpen(i)">
						<div class="qna-q-box">
							<div class="qna-q"><span style="padding-right: 10px;">Q.</span>{{ row.contentTitle }}</div>
							<div class="arrow-box">
								<font-awesome-icon v-if="!row.viewOpen" class="arrow" icon="chevron-down" />
								<font-awesome-icon v-else class="arrow" icon="chevron-up" />
							</div>
						</div>
						<div class="qna-a" v-show="row.viewOpen">
							<pre class="ma-0" style="padding-left: 26px; white-space: pre-wrap;">{{ row.contentBody }}</pre>
						</div>
					</div>
				</article>
			</section>

			<paging :total-count="totalCount" :page="listPage" :rows="listPageRow" :click="pageClick" />
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import Paging from '@/components/common/Paging';
import eventBus from '@/plugins/event-bus';

export default {
	components: { Paging },
	title: 'Q&A 목록',
	name: 'BoardList',
	props: ['viewType'],
	data: function() {
		return {
			loginMember: null,
			select: 1,
			isTableResize: false,
			colAutoWidth: 0,
			keywords: '',
			listPage: 1,
			listPageRow: 10,
			totalCount: 0,

			qnaType: '',
			qnaTypeList: [
				{ code: 'PROGRAM', name: '프로그램' },
				{ code: 'FEE', name: '정산' },
				{ code: 'ETC', name: '기타' },
			],
			boardList: null,
		};
	},
	computed: {},
	watch: {
		viewType: function(v) {
			this.keywords = '';
			this.qnaType = '';
			this.listPage = 1;
			if (v === 'consult') {
				// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA_CONSULT');
				this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
			} else if (v === 'qna') {
				this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA');
			} else {
				// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA_RECEIVE');
				this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
			}
			this.getBoardList();
		},
		qnaType: function() {
			this.getBoardList();
		},
	},
	created() {
		eventBus.$on('LOAD_QNA_DATA', v => {
			this.keywords = v;
			this.$nextTick(this.getBoardList.bind(this));
		});
	},
	mounted() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		this.$nextTick(this.getBoardList.bind(this));
		if (this.viewType === 'consult') {
			// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA_CONSULT');
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		} else if (this.viewType === 'qna') {
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA');
		} else {
			// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA_RECEIVE');
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		}
	},
	beforeDestroy() {
		window.onresize = null;
	},
	methods: {
		showOpen: function(i) {
			let viewOpen = this.boardList[i].viewOpen;
			this.$delete(this.boardList[i], 'viewOpen');
			this.$set(this.boardList[i], 'viewOpen', !viewOpen);
		},
		moveDetail: function(seqNo, regSeqNo) {
			if (this.viewType === 'consult') {
				let myModify = this.loginMember.seqNo == regSeqNo ? true : false;
				this.$device.pushView('/qna/' + this.viewType + '/detail/' + seqNo + '/' + myModify);
			} else if (this.viewType !== 'consult' && this.viewType !== 'qna') {
				this.$device.pushView('/qna/' + this.viewType + '/detail/' + seqNo);
			}
		},
		searchKeyword: function() {
			this.listPage = 1;
			this.$nextTick(this.getBoardList.bind(this));
		},
		pageClick: function(p) {
			this.listPage = p;
			this.$nextTick(this.getBoardList.bind(this));
		},
		getBoardList: function() {
			this.boardList = [];
			let formData = new FormData();
			let url = '';
			let returnUrl = '';
			formData.append('keywords', this.keywords);
			formData.append('page', this.listPage);
			formData.append('row', this.listPageRow);
			if (this.viewType !== 'consult' && this.viewType !== 'qna') {
				//쪽지함
				formData.append('userType', this.loginMember.budsUserType);
				formData.append('listType', this.viewType);
				url = '/api/board/getInboxList.do';
				returnUrl = '/qna/receive';
				if (this.viewType === 'send') formData.append('sendUserSeqNo', this.loginMember.seqNo);
				else formData.append('receiveUserSeqNo', this.loginMember.seqNo);
			} else if (this.viewType === 'consult') {
				//온라인상담
				formData.append('qnaType', this.qnaType);
				formData.append('orderType', 'regDate');
				formData.append('listOrder', 'desc');
				url = '/api/board/getConsultList.do';
				returnUrl = '/qna/consult';
			} else if (this.viewType === 'qna') {
				//자주하는질문
				formData.append('orderType', 'regDate');
				formData.append('listOrder', 'desc');
				formData.append('boardType', 'FAQ');
				url = '/api/board/getBoardList.do';
				returnUrl = '/qna/qna';
			}
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + url, formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
						this.$device.pushView(returnUrl);
					} else {
						this.boardList = res.data.data;
						if (this.viewType === 'qna' && this.boardList.length > 0) {
							for (let i = 0; i < this.boardList.length; i++) {
								this.boardList[i].viewOpen = false;
							}
						}
						this.totalCount = res.data.dataCount;
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
	},
};
</script>

<style scoped></style>
